import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { SelfOnboardingServiceModel } from '@savgroup-front-common/types/Onboarding/ServiceModel';

const ENDPOINT = `${APIConfiguration.repairer}selfonboarding/service`;

interface GetSelfOnboardingActorsQueryPayload {
  sellerId?: string;
}

async function getSelfOnboardingServicesQuery({
  sellerId,
}: GetSelfOnboardingActorsQueryPayload): Promise<
  BackResponse<SelfOnboardingServiceModel[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, {
      sellerId,
    });

    const response = await apiCall<BackResponse<SelfOnboardingServiceModel[]>>(
      url,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getSelfOnboardingServicesQuery;
